import React, { Component } from "react";
import { Redirect, BrowserRouter as Router, NavLink } from "react-router-dom";
import { Drawer, Spin } from "antd";
import MirraLogo from "../images/new_mirra_logo_small.png";
import ElibilityIcon from "../images/Eligible.svg";
import "./Sidebar.css";
import claim from "../images/Claims.svg";
// import ReportsIcon from '../images/Inactive_Reports.svg';
import ProfileIcon from "../images/profileicon.svg";
import MemberIcon from "../images/Member.svg";
// import Ic4 from "../images/Ic4.svg";
import Ic4 from "../images/userlist.svg";
// import ReportImg from "../images/Inactive_Reports.svg";
import EligibilityActive from "../images/E_C_Active.svg";
import AuthActive from "../images/Auth_Active.svg";
import UserActive from "../images/User_Active.svg";
import ReportActive from "../images/Active_Reports.svg";
import ClaimsActive from "../images/Claims_Active.svg";
import ReportImg from "../images/Inactive_Reports_Icon.svg";
import CloseIcon from "../images/Close.svg";
import Profile from "../images/Profile.svg";
import Notify from "../images/Notify.svg";
import Message from "../images/message.svg";
import ApplicationGuide from "../images/ApplicationGuide.svg";
import ProfileSearchInActive from "../images/BoxSearchIcon.svg";
import ProfileSearchActive from "../images/ProfileSearchActive.svg";
import Auth from "../images/AuthListIcon.png";
import QueuesIcon from "../images/Group 3700(1).svg";
import ActiveQueues from "../images/Queues_Active.svg";
import ChaptershospiceIcon from "../images/ReportLogos/chaptershospiceIcon.png";
import SolisLogo from "../images/ReportLogos/Solis-New LOGO 2025.png";
import securLogo from '../images/ReportLogos/SCR-SECUR-VerticalColorLogo.png';
import cshLogo from '../images/ReportLogos/cshSidebarLogo.png';
import AttestationInactive from "../images/AttestationInactive.png";
import AttestationPending from "../images/AttestationPending.png";
import AttestationPending2 from "../images/AttestationPending2.png";
import AttestationActive from "../images/AttestationActive.png";

export default class sidebarDrawer extends Component {
  constructor() {
    super();
    this.state = {
      placement: "left",
      id: 1,
      current: "1",
      pagePathName: window.location.pathname.toString().toLowerCase(),
      isCSNPLoading: true
    };
  }

  getRoterIndex = (key) => {
    this.props.GetIndex(key);
  };

  checkGroupUsers = () => {
    // this method will check for Group User & IPA User
    let roles = sessionStorage.getItem("rolename");
    return (
      roles && (roles.includes("Group User") || roles.includes("IPA User"))
    );
  };

  tempNonAdminCheck = () => {
    if(sessionStorage.getItem("PlanAdminRole") !== "Plan Admin"){
      if(!sessionStorage.getItem("taxidNpiMapping") 
      && !sessionStorage.getItem("taxid") 
      && !sessionStorage.getItem("npivalue"))
        return false;
    }
    return true;
  }

  openDocument = () => {
    let a = document.getElementById("appGuide");
    a.target = "_blank";
    a.href = sessionStorage.getItem("ApplicationGuideURL");
  };
  componentDidMount() {
    //this.showApplicationGuide();
    this.setState({
      isCSNPLoading:
        sessionStorage.getItem("IsCSNPPendingLoading") === "true"
    });
  
    window.addEventListener(
      "csnpResponseReceived",
      this.handleCSNPResponse
    );
  }
  componentWillUnmount() {
    window.removeEventListener(
      "csnpResponseReceived",
      this.handleCSNPResponse
    );
  }
  handleCSNPResponse = (event) => {
    this.setState({
      isCSNPLoading: false
    });
  }; 

  render() {
    const planName = sessionStorage.getItem("planName");
    const isPending =
  localStorage.getItem("IsCSNPPending") === "true" ||
  localStorage.getItem("IsSSBCIPending") === "true";
    console.log(this.props.Index);
    let userEmail = sessionStorage.getItem("userName");
    return (
      <Drawer
        placement={this.state.placement}
        closable={false}
        onClose={this.props.onClose}
        visible={this.props.visible}
        key={this.state.placement}
        width="230px"
      >
        <div className="sidebar-expansion" style={{ height: "100%" }}>
          <div className="sidebar-expansion-list">
            <div
              className="sidebar-expansion-logo mb-4"
              style={{ height: "10%" }}
            >
              <img 
               src={sessionStorage.getItem("planName") === "csh" ? cshLogo : MirraLogo}
              alt="Logo"
              className="logo-img " 
              style={{
                height: sessionStorage.getItem("planName") === "csh" ? "40px" : "60px", // Adjusted image height
                width: sessionStorage.getItem("planName") === "csh" ? "30px" : "60px",   // Added image width
                objectFit: "contain", // Ensures the image scales down within its dimensions
                marginLeft: "10px", // Add some space between logo and text
                marginBottom: "1px",
              }}
              />
              <span className="ml-2 mt-1">
                <b style={{ color: "#16345F" }}>Provider Portal</b>
              </span>
            </div>

           {
            sessionStorage.getItem('planName') === 'solis'&&
            <div
              className=" mb-4"
              style={{ height: "10%" }}
            >
              <img src={SolisLogo} alt="Logo" className="solis-img " />
            </div>
           }
           {
            sessionStorage.getItem('planName') === 'chaptershospice'&&
            <div
              className=" mb-4"
              style={{ height: "10%" }}
            >
              <img src={ChaptershospiceIcon} alt="Logo" className="solis-img " />
            </div>
           }
           {
            sessionStorage.getItem('planName') === 'secur'&&
            <div
              className=" mb-4"
              style={{ height: "10%" }}
            >
              <img src={securLogo} alt="Logo" className="solis-img " />
            </div>
           }
           {/* {
            sessionStorage.getItem('planName') === 'csh' &&
            <div
              className=" mb-4"
              style={{ height: "10%" }}
            >
              <img src={cshLogo} alt="Logo" className="solis-img " />
            </div>
           } */}

            <div className="sidebar-expansion-images-list">
              <ul style={{ height: sessionStorage.getItem('planName') === 'ultimate' ? "50%" : "60%" }}>

                {/* 1️⃣ Eligibility Check */}
                {((sessionStorage.getItem("ProviderRole") === "PROVIDER" ||
                  this.checkGroupUsers() ||
                  sessionStorage.getItem("PlanAdminRole") === "Plan Admin")
                  && sessionStorage.getItem("planName") === "csh"
                ) && (
                    <li className="mb-4" onClick={() => this.getRoterIndex(1)}>
                      <NavLink
                        to="/EligibilityCheck"
                        exact
                        activeStyle={{
                          backgroundColor: "#427BDDEB",
                          padding: "10px 54px 10px 10px",
                          borderRadius: "4px",
                        }}
                      >
                        {this.state.pagePathName === "/eligibilitycheck"
                          ? <img src={EligibilityActive} alt="EligibilityCheck" />
                          : <img src={ElibilityIcon} alt="EligibilityCheck" />}
                        <span className={this.props.Index === 1
                          ? "sidebar-expansion-li sidebar-expansion-li-white"
                          : "sidebar-expansion-li sidebar-expansion-li-gray"}>
                          Member Search
                        </span>
                      </NavLink>
                    </li>
                  )}

                {/* 2️⃣ Member Search */}
                {sessionStorage.getItem("AdminRole") === "User Admin" &&
                  (sessionStorage.getItem("ProviderRole") === "PROVIDER" ||
                    this.checkGroupUsers() ||
                    sessionStorage.getItem("PlanAdminRole") === "Plan Admin") &&
                    sessionStorage.getItem("planName") !== "csh" &&
                  sessionStorage.getItem("planName") !== "solis" &&
                  sessionStorage.getItem("EligibilityOnlyFlag") === "false" &&
                  <li className="mb-4" onClick={() => this.getRoterIndex(3)}>
                    <NavLink
                      to="/Search_member"
                      exact
                      activeStyle={{
                        backgroundColor: "#427BDDEB",
                        padding: "10px 54px 10px 10px",
                        borderRadius: "4px",
                      }}
                    >
                      {this.state.pagePathName === "/search_member"
                        ? <img src={ProfileSearchActive} alt="Search_member" />
                        : <img src={ProfileSearchInActive} alt="Search_member" />}
                      <span className={this.props.Index === 3
                        ? "sidebar-expansion-li sidebar-expansion-li-white"
                        : "sidebar-expansion-li sidebar-expansion-li-gray"}>
                        Member Search
                      </span>
                    </NavLink>
                  </li>
                }

                {/* 3️⃣ Claims Search */}
                {sessionStorage.getItem("AdminRole") === "User Admin" &&
                  (sessionStorage.getItem("ProviderRole") === "PROVIDER" ||
                    this.checkGroupUsers() ||
                    sessionStorage.getItem("PlanAdminRole") === "Plan Admin") &&
                  sessionStorage.getItem("EligibilityOnlyFlag") === "false" &&
                  this.tempNonAdminCheck() &&
                  <li className="mb-4" onClick={() => this.getRoterIndex(2)}>
                    <NavLink
                      to="/ClaimsTable"
                      exact
                      activeStyle={{
                        backgroundColor: "#427BDDEB",
                        padding: "10px 54px 10px 10px",
                        borderRadius: "4px",
                      }}
                    >
                      {this.state.pagePathName === "/claimstable"
                        ? <img src={ClaimsActive} alt="ClaimsTable" />
                        : <img src={claim} alt="ClaimsTable" />}
                      <span className={this.props.Index === 2
                        ? "sidebar-expansion-li sidebar-expansion-li-white"
                        : "sidebar-expansion-li sidebar-expansion-li-gray"}>
                        Claim Search
                      </span>
                    </NavLink>
                  </li>
                }

                {/* 4️⃣ Authorization Search */}
                {sessionStorage.getItem("AdminRole") === "User Admin" &&
                  (sessionStorage.getItem("ProviderRole") === "PROVIDER" ||
                    this.checkGroupUsers() ||
                    sessionStorage.getItem("PlanAdminRole") === "Plan Admin") &&
                  (["ultimate", "sonder", "demo", "solis", "secur","csh"].includes(sessionStorage.getItem("planName"))) &&
                  sessionStorage.getItem("EligibilityOnlyFlag") === "false" &&
                  sessionStorage.getItem("planName") !== "PodAmerica" &&
                  sessionStorage.getItem("planName") !== "chapters" &&
                  this.tempNonAdminCheck() &&
                  <li className="mb-4" onClick={() => this.getRoterIndex(4)}>
                    <NavLink
                      to="/auth_user_list"
                      exact
                      activeStyle={{
                        backgroundColor: "#427BDDEB",
                        padding: "10px 54px 10px 10px",
                        borderRadius: "4px",
                      }}
                    >
                      {this.state.pagePathName === "/auth_user_list"
                        ? <img src={AuthActive} alt="List" />
                        : <img style={{ width: "25px" }} src={Auth} alt="List" />}
                      <span className={this.props.Index === 4
                        ? "sidebar-expansion-li sidebar-expansion-li-white"
                        : "sidebar-expansion-li sidebar-expansion-li-gray"}>
                        Auth List
                      </span>
                    </NavLink>
                  </li>
                }

                {/* 5️⃣ Attestation Search (Only Solis) */}
                {(planName === "solis" || planName === "ultimate") &&
                  sessionStorage.getItem("EligibilityOnlyFlag") === "false" &&
                  <li className="mb-4" onClick={() => this.getRoterIndex(8)}>
                    <NavLink
                      to="/attestation"
                      exact
                      style={{ textDecoration: "none" }}
                      activeStyle={{
                        backgroundColor: "#427BDDEB",
                        borderRadius: "4px",
                        display: "flex",
                        alignItems: "center",
                        padding: "10px",
                      }}
                    >
                      <span title="Attestation Search">
                  { this.state.isCSNPLoading ? (
                    <div>
                    <Spin size="small"/> {/* Spinner overlay while loading */}
                  </div>
                     ) :
                    this.state.pagePathName === "/attestation" ? (
                      (localStorage.getItem("IsCSNPPending") === "true" ||
                        localStorage.getItem("IsSSBCIPending") === "true") ? (
                          <>
                        <img src={AttestationPending2} alt="pending" style={{ cursor: "pointer", width: "25px", height: "25px", marginLeft: "0px" }} />
                        <span
                        className="sidebar-expansion-li"
                        style={{
                          color: isPending ?"#8B1E1E" : "#808080",
                          fontWeight: isPending ? "600" : "normal",
                          }}
                          >
                            Attestation Search
                            </span>
                        </>
                      ) : (
                        <>
                        <img src={AttestationInactive} alt="attestation" style={{ cursor: "pointer", width: "20px", height: "20px", marginLeft: "0px" }} />
                        <span
                        className="sidebar-expansion-li"
                        style={{
                          color: isPending ? "#8B1E1E" : "#808080",
                          fontWeight: isPending ? "600" : "normal",
                          }}
                          >
                            Attestation Search
                            </span>
                          </>
                      )
                    ) : (
                      (localStorage.getItem("IsCSNPPending") === "true" ||
                        localStorage.getItem("IsSSBCIPending") === "true") ? (
                          <>
                        <img src={AttestationPending2} alt="pending" style={{ cursor: "pointer", width: "30px", height: "30px", marginLeft: "0px" }} />
                        <span
                        className="sidebar-expansion-li"
                        style={{
                          color: isPending ? "#8B1E1E" : "#808080",
                          fontWeight: isPending ? "600" : "normal",
                          }}
                        >
                          Attestation Search
                        </span>
                        </>
                      ) : (
                        <>
                        <img src={AttestationActive} alt="attestation" style={{ cursor: "pointer", width: "30px", height: "30px", marginLeft: "0px" }} />
                        <span
                        className="sidebar-expansion-li"
                        style={{
                          color: isPending ? "#8B1E1E" : "#808080",
                          fontWeight: isPending ? "600" : "normal",
                          }}
                          >
                            Attestation Search
                            </span>
                        </>
                      )
                    )
                    }
                  </span>
                    </NavLink>
                  </li>
                }

                {/* 6️⃣ User Search */}
                {sessionStorage.getItem("AdminRole") === "User Admin" &&
                  (sessionStorage.getItem("ProviderRole") === "PROVIDER" ||
                    this.checkGroupUsers() ||
                    sessionStorage.getItem("PlanAdminRole") === "Plan Admin") &&
                  sessionStorage.getItem("EligibilityOnlyFlag") === "false" &&
                  <li className="mb-4">
                    <NavLink
                      to="/userDetails"
                      exact
                      activeStyle={{
                        backgroundColor: "#427BDDEB",
                        padding: "10px 54px 10px 10px",
                        borderRadius: "4px",
                      }}
                      onClick={() => this.getRoterIndex(5)}
                    >
                      {this.state.pagePathName === "/userdetails"
                        ? <img src={UserActive} alt="List" />
                        : <img src={Ic4} alt="List" />}
                      <span className={this.props.Index === 5
                        ? "sidebar-expansion-li sidebar-expansion-li-white"
                        : "sidebar-expansion-li sidebar-expansion-li-gray"}>
                        List User
                      </span>
                    </NavLink>
                  </li>
                }

                {/* 7️⃣ Reports */}
                {sessionStorage.getItem("AdminRole") === "User Admin" &&
                  (["ultimate", "csh", "demo", "solis", "secur"].includes(sessionStorage.getItem("planName"))) &&
                  (sessionStorage.getItem("ProviderRole") === "PROVIDER" ||
                    this.checkGroupUsers() ||
                    sessionStorage.getItem("PlanAdminRole") === "Plan Admin") &&
                  sessionStorage.getItem("EligibilityOnlyFlag") === "false" &&
                  sessionStorage.getItem("planName") !== "PodAmerica" &&
                  sessionStorage.getItem("planName") !== "sonder" &&
                  sessionStorage.getItem("planName") !== "chapters" &&
                  this.tempNonAdminCheck() &&
                  <li className="mb-4" onClick={() => this.getRoterIndex(6)}>
                    <NavLink
                      to="/reports"
                      exact
                      activeStyle={{
                        backgroundColor: "#427BDDEB",
                        padding: "10px 54px 10px 10px",
                        borderRadius: "4px",
                      }}
                    >
                      {this.state.pagePathName === "/reports"
                        ? <img src={ReportActive} alt="reports" />
                        : <img src={ReportImg} alt="reports" />}
                      <span className={this.props.Index === 6
                        ? "sidebar-expansion-li sidebar-expansion-li-white"
                        : "sidebar-expansion-li sidebar-expansion-li-gray"}>
                        Reports
                      </span>
                    </NavLink>
                  </li>
                }

              </ul>
            </div>

            <hr className="horizontal-devider mb-4" />

            <div
              className="sidebar-expansion-images-list-div"
              style={{ height: "25%" }}
            >
              <div className="mb-4">
                <ul>
                  <li onClick={() => this.openDocument()}>
                    <a id="appGuide">
                      <img
                        src={ApplicationGuide}
                        className="notification applicationGuide"
                        alt="ApplicationGuide"
                        style={{ marginLeft: "-5px" }}
                      />
                      <span className="ml-3 mr-4 sencon-ul-text">
                      User Guide
                      </span>
                      {/* <span className="notification-value-card ml-2">02</span> */}
                    </a>
                  </li>
                </ul>
              </div>
              {/* <div className="mb-4">
                <ul>
                  <li>
                    <img
                      src={Notify}
                      className="notification"
                      alt="Notification"
                    />
                    <span className="ml-4 mr-4 sencon-ul-text">
                      Notifications
                    </span>
                    
                  </li>
                </ul>
              </div> */}

              {/* <div className="mb-4">
                <ul>
                  <li>
                    <img
                      src={Message}
                      className="drawer-message"
                      alt="Messages"
                    />
                    <span className="ml-3 mr-4 sencon-ul-text">Inbox</span>
                    
                  </li>
                </ul>
              </div> */}

              <div>
                <ul className="mcd-menu">
                  {sessionStorage.getItem("AdminRole") === "User Admin" &&
                  sessionStorage.getItem("ProviderRole") === "PROVIDER" ? (
                    <li>
                      <NavLink
                        to="/Profile"
                        exact
                        activeStyle={{
                          backgroundColor: "#427BDDEB",
                          padding: "5px 54px 5px 5px",
                          borderRadius: "4px",
                        }}
                        onClick={() => this.getRoterIndex(7)}
                      >
                        <img
                          src={Profile}
                          className="mcd-menu userEffect"
                          alt="User"
                          width="26"
                          height="26"
                        />
                        <span className="ml-4 mr-4 sencon-ul-text">
                          Provider Profile
                        </span>
                      </NavLink>
                    </li>
                  ) : sessionStorage.getItem("ProviderRole") === "PROVIDER" ? (
                    <li>
                      <NavLink
                        to="/Profile"
                        exact
                        activeStyle={{
                          backgroundColor: "#427BDDEB",
                          padding: "5px 54px 5px 5px",
                          borderRadius: "4px",
                        }}
                        onClick={() => this.getRoterIndex(7)}
                      >
                        <img
                          src={Profile}
                          className="mcd-menu userEffect"
                          alt="User"
                          width="26"
                          height="26"
                        />
                        <span className="ml-4 mr-4 sencon-ul-text">
                          Provider Profile
                        </span>
                      </NavLink>
                    </li>
                  ) : (
                    // <li>
                    //   <NavLink
                    //     to="/Profile"
                    //     exact
                    //     activeStyle={{
                    //       backgroundColor: "#427BDDEB",
                    //       padding: "4px 54px 6px 4px",
                    //       borderRadius: "4px",
                    //     }}
                    //     onClick={() => this.getRoterIndex(4)}
                    //   >
                    //     <img
                    //       src={Profile}
                    //       className="mcd-menu userEffect"
                    //       alt="User"
                    //       width="26"
                    //       height="26"
                    //     />
                    //     <span className="ml-4 mr-4 sencon-ul-text">
                    //       Provider Profile
                    //     </span>
                    //   </NavLink>
                    // </li>
                    ""
                  )}
                </ul>
              </div>
            </div>
            {/* Close button */}
            <div style={{ height: "10%", marginLeft: "40%" }}>
              <ul className="mcd-menu mt-3 mb-1 ml-1">
                <li>
                  <img
                    src={CloseIcon}
                    className="mcd-menu userEffect"
                    alt="User"
                    width="50"
                    height="50"
                    onClick={this.props.onClose}
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </Drawer>
    );
  }
}
